import React, { useContext } from 'react';

import Controls from './Controls';
import Integrations from 'src/presentation/components/pages/sidekick/threads/components/Integrations/Integrations';
import SidePanelHeader from './SidePanelHeader';
import { ThreadModuleContext } from './ThreadModuleContext';

function ModifierForm() {
  const { modifierSpec, modifier } = useContext(ThreadModuleContext);

  if (!modifier || !modifierSpec) {
    return null;
  }

  const controlCategorySpecs = modifierSpec.controlCategories;

  return (
    <>
      <SidePanelHeader spec={modifierSpec} />
      <Integrations spec={modifierSpec} />
      <Controls controlCategorySpecs={controlCategorySpecs} />
    </>
  );
}

export default ModifierForm;
